import * as React from "react";

import { cn } from "@/lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-9 max-sm:h-11 w-full min-w-0 rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-xs transition-[color,box-shadow] outline-none file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20",
          // Zahlen stehen rechtsbündig — dann fluchten Einer, Zehner und Hunderter untereinander,
          // und zwei Felder nebeneinander lassen sich der Größe nach vergleichen. `tabular-nums`
          // gehört dazu: Ohne gleich breite Ziffern verrutscht die Flucht beim Tippen wieder.
          // Steht hier und nicht am einzelnen Feld, weil es eine Regel ist und keine Ausnahme;
          // wer sie umkehren muss, gibt `text-left` über `className` mit.
          type === "number" && "text-right tabular-nums",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
